module.exports = __webpack_public_path__ + "static/media/loading.4b85ddbe.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/loading.gif
// module id = 589
// module chunks = 0